<template>
    <v-layout align-center justify-center class="mb-6">
        <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
        <v-flex xs12 sm9 md6 lg4 class="pb-4">
            <v-img :src="'/img/logo-credireinicia' + ($vuetify.theme.dark ? '-white' : '') + '.png'" class="px-6 mb-3" max-height="80" contain/>
            <v-card flat color="transparent" class="mx-3">
                <v-toolbar flat :color="'grey ' + (!$vuetify.theme.dark ? 'light' : 'dark') + 'en-4'" class="mb-4">
                    <v-toolbar-title
                        class="text-center font-weight-bold primary--text text-subtitle-1 text-sm-h5"
                        style="white-space: normal; width: 100%">CREAR CUENTA
                    </v-toolbar-title>
                    <div class="flex-grow-1"></div>
                </v-toolbar>
                <!--v-card-actions class="justify-space-around">
                    <facebook/>
                    <google/>
                </v-card-actions>
                <v-card-text class="text-center title py-2 pb-0">-o- Escribe tus Datos</v-card-text-->
            </v-card>
            <v-card flat color="transparent" class="ma-3">
                <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                    <v-card-text class="px-0 pb-0">
                        <v-text-field
                            :label="labels.name"
                            type="text"
                            name="name"
                            v-model="form.name"
                            :error-messages="errors.name"
                            :rules="[rules.required('name'), rules.max('name', 50, 'El')]"
                            :disabled="loading"
                            @input="clearErrors('name')"
                            prepend-inner-icon="mdi-account-circle"
                            filled/>
                        <v-text-field
                            :label="labels.lname"
                            type="text"
                            name="lname"
                            v-model="form.lname"
                            :error-messages="errors.lname"
                            :rules="[rules.required('lname'), rules.max('lname', 50, 'El')]"
                            :disabled="loading"
                            @input="clearErrors('lname')"
                            prepend-inner-icon="mdi-account-circle"
                            filled/>
                        <v-text-field
                            :label="labels.phone"
                            name="phone"
                            type="tel"
                            inputmode="tel"
                            v-model="form.phone"
                            :error-messages="errors.phone"
                            :rules="[rules.required('phone'), rules.equal('phone', 11, 10, 'El')]"
                            :disabled="loading"
                            @input="clearErrors('phone')"
                            prepend-inner-icon="mdi-cellphone"
                            hint="Ejemplo: 301 2345678"
                            v-mask="mask"
                            filled/>
                        <v-text-field
                            :label="labels.email"
                            type="email"
                            name="email"
                            inputmode="email"
                            v-model="form.email"
                            :error-messages="errors.email"
                            :rules="[rules.required('email'), rules.mail('email')]"
                            :disabled="loading"
                            @input="clearErrors('email')"
                            prepend-inner-icon="mdi-email"
                            filled/>
                        <v-text-field
                            :label="labels.password"
                            name="password"
                            v-model="form.password"
                            :append-icon="passwordHidden ? 'mdi-eye-off' : 'mdi-eye'"
                            @click:append="() => (passwordHidden = !passwordHidden)"
                            :type="passwordHidden ? 'password' : 'text'"
                            :error-messages="errors.password"
                            :disabled="loading"
                            :rules="[rules.req('password'), rules.min('password', 8, 'La')]"
                            hint="Mínimo 8 caracteres"
                            @input="clearErrors('password')"
                            prepend-inner-icon="mdi-lock"
                            filled/>
                        <v-text-field
                            :label="labels.password_confirmation"
                            name="password_confirmation"
                            v-model="form.password_confirmation"
                            :append-icon="passwordHidden ? 'mdi-eye-off' : 'mdi-eye'"
                            @click:append="() => (passwordHidden = !passwordHidden)"
                            :type="passwordHidden ? 'password' : 'text'"
                            :error-messages="errors.password_confirmation"
                            :disabled="loading"
                            :rules="[rules.req('password_conf')]"
                            @input="clearErrors('password')"
                            prepend-inner-icon="mdi-lock"
                            filled/>
                        <v-switch name="terms" v-model="form.terms" :disabled="loading" class="mt-0"
                                  :rules="[rules.cond('terms')]" :error-messages="errors.terms"
                                  @input="clearErrors('terms')" color="success" readonly @click="terms = true">
                            <template v-slot:label>
                                <div><strong @click="terms = true">Acepto los {{ labels.terms }}.</strong></div>
                            </template>
                        </v-switch>
                        <v-switch name="privacy" v-model="form.privacy" :disabled="loading" class="mt-0"
                                  :rules="[rules.cond('privacy')]" :error-messages="errors.privacy"
                                  @input="clearErrors('privacy')" color="success" readonly @click="privacy = true">
                            <template v-slot:label>
                                <div><strong @click="privacy = true">Acepto la {{ labels.privacy }}.</strong></div>
                            </template>
                        </v-switch>
                        <v-switch name="cookies" v-model="form.cookies" :disabled="loading" class="mt-0"
                                  :rules="[rules.cond('cookies')]" :error-messages="errors.cookies"
                                  @input="clearErrors('cookies')" color="success" readonly @click="cookies = true">
                            <template v-slot:label>
                                <div><strong @click="cookies = true">Acepto la {{ labels.cookies }}.</strong></div>
                            </template>
                        </v-switch>
                        <v-switch name="data" v-model="form.data" :disabled="loading" class="mt-0"
                                  :rules="[rules.cond('data')]" :error-messages="errors.data"
                                  @input="clearErrors('data')" color="success" readonly @click="data = true">
                            <template v-slot:label>
                                <div><strong @click="data = true">Acepto la {{ labels.data }}.</strong></div>
                            </template>
                        </v-switch>
                    </v-card-text>
                    <v-card-actions class="px-0">
                        <v-btn
                            type="submit"
                            :loading="loading"
                            :disabled="loading || !valid"
                            color="primary"
                            class="font-weight-bold"
                            large block
                        >Crear Cuenta</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
            <div class="text-center py-2 py-sm-4 hidden-md-and-down">
                ¿Ya tienes una cuenta?&nbsp;&nbsp;
                <v-btn color="secondary primary--text" to="/login">Ingresar</v-btn>
            </div>
            <v-dialog v-model="terms" persistent scrollable width="800px">
                <v-card>
                    <v-card-title class="text-center headline primary d-inline-block" primary-title style="color: #fefefe; word-break: normal; width: 100%">{{labels.terms}}</v-card-title>
                    <v-card-text class="px-0">
                        <terms :style="'margin-top: -' + mrg + 'px'" :w="'100'"/>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions class="px-sm-8">
                        <v-btn color="error" large @click="[terms = false, form.terms = false]">
                            <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;No acepto
                        </v-btn>
                        <v-spacer/>
                        <v-btn color="success" large @click="[terms = false, form.terms = true]">
                            <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Acepto
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="privacy" persistent scrollable width="800px">
                <v-card>
                    <v-card-title class="text-center headline primary d-inline-block" primary-title style="color: #fefefe; word-break: normal; width: 100%">{{ labels.privacy }}</v-card-title>
                    <v-card-text class="px-0">
                        <privacy :style="'margin-top: -' + mrg + 'px'" :w="'100'"/>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions class="px-sm-8">
                        <v-btn color="error" large @click="[privacy = false, form.privacy = false]">
                            <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;No acepto
                        </v-btn>
                        <v-spacer/>
                        <v-btn color="success" large @click="[privacy = false, form.privacy = true]">
                            <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Acepto
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="cookies" persistent scrollable width="800px">
                <v-card>
                    <v-card-title class="text-center headline primary d-inline-block" primary-title style="color: #fefefe; word-break: normal; width: 100%">{{ labels.cookies }}</v-card-title>
                    <v-card-text class="px-0">
                        <cookies :style="'margin-top: -' + mrg + 'px'" :w="'100'"/>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions class="px-sm-8">
                        <v-btn color="error" large @click="[cookies = false, form.cookies = false]">
                            <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;No acepto
                        </v-btn>
                        <v-spacer/>
                        <v-btn color="success" large @click="[cookies = false, form.cookies = true]">
                            <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Acepto
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="data" persistent scrollable width="800px">
                <v-card>
                    <v-card-title class="text-center headline primary d-inline-block" primary-title style="color: #fefefe; word-break: normal; width: 100%">{{ labels.data }}</v-card-title>
                    <v-card-text class="px-0">
                        <eData :style="'margin-top: -' + mrg + 'px'" :w="'100'"/>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions class="px-sm-8">
                        <v-btn color="error" large @click="[data = false, form.data = false]">
                            <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;No acepto
                        </v-btn>
                        <v-spacer/>
                        <v-btn color="success" large @click="[data = false, form.data = true]">
                            <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Acepto
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";
import Form from "../../helpers/form";
import { mask } from "vue-the-mask";
import { isMobileOnly } from "mobile-device-detect";
import Terms from "../Terms";
import Privacy from "../Privacy";
import Cookies from "../Cookies";
import eData from "../Data";
import Facebook from "./providers/Facebook";
import Google from "./providers/Google";

export default {
    name: "Register",
    components: { Google, Facebook, Terms, Privacy, Cookies, eData },
    mixins: [ Form ],
    directives: { mask },
    data: () => ({
        terms: false,
        privacy: false,
        cookies: false,
        data: false,
        passwordHidden: true,
        mrg: isMobileOnly ? '74' : '54',
        labels: {
            name: 'Nombre(s)',
            lname: 'Apellido(s)',
            phone: 'Telefono',
            email: 'Correo Electrónico',
            password: 'Contraseña',
            password_conf: 'confirmación de la contraseña',
            password_confirmation: 'Confirmar Contraseña',
            terms: 'Términos y Condiciones',
            privacy: 'Política de Privacidad',
            cookies: 'Política de Cookies',
            data: 'Política de Tratamientos de Datos'
        },
        form: {
            name: null,
            lname: null,
            phone: null,
            email: null,
            password: null,
            password_confirmation: null,
            terms: false,
            privacy: false,
            cookies: false,
            data: false
        },
        mask: '### #######'
    }),
    mounted() {},
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                axios.post('/api/register', this.form).then((res) => {
                    this.$toast.success('¡Te has registrado exitosamente!', {icon: 'mdi-check-circle'});
                    this.success(res.data);
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                })
            }
        },
        success(data) {
            this.$store.dispatch('saveToken', data);
            this.$store.dispatch('setUser', data);
            this.$router.push({ name: 'Home' });
        }
    }
}
</script>

<style scoped>

</style>
